import type { Command, ConversationTurnEntry } from '@/index'

export function isCommandPending(
  latestCommand: Command | undefined,
  latestEvent: ConversationTurnEntry | undefined,
): boolean {
  return (
    latestCommand !== undefined && (!latestEvent || latestCommand.timestamp > latestEvent.timestamp)
  )
}
